import React from "react";
import { AccordionItem, Form, Select } from "components";
import { OrganizationSetting } from "../../../../duck";
import { DATE_FORMATS, FormValues, useUpdateDateFormat } from "./duck";

interface DateFormatProps {
  settings: OrganizationSetting;
}

const DateFormat: React.FC<DateFormatProps> = ({ settings }) => {
  const handleChange = useUpdateDateFormat(settings._id);

  return (
    <AccordionItem title="Date format">
      <Form<FormValues> defaultValues={{ dateFormat: settings.dateFormat }}>
        <Form.Watcher
          defaultValues={{ dateFormat: settings.dateFormat }}
          onChange={handleChange}
        />
        <Select
          isClearable={false}
          options={DATE_FORMATS}
          name="dateFormat"
          label="Date format"
          placeholder="Date format"
        />
      </Form>
    </AccordionItem>
  );
};

export default DateFormat;
